import { render, staticRenderFns } from "./trev-form-creator.vue?vue&type=template&id=456fcf3a&"
import script from "./trev-form-creator.vue?vue&type=script&lang=js&"
export * from "./trev-form-creator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports